import { Outlet } from "react-router-dom";

export default function InitialPage() {
  return (
    <main>
      <Outlet />
    </main>
  );
}
